<h2 mat-dialog-title>Feedback</h2>

<mat-dialog-content>
  <p>Thanks, your feedback makes EVA better.</p>
  <p>What other details should EZLynx know (e.g. inaccurate, unhelpful, etc.)?</p>
  <form [formGroup]="evaFeedbackForm"
        class="negative-feedback">
    <mat-form-field subscriptSizing="dynamic"
                    class="full-width">
      <mat-label>Reason for Feedback (Optional)</mat-label>
      <textarea matInput
                rows="3"
                [formControl]="evaFeedbackForm.controls.feedbackCtrl"></textarea>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button type="button"
          mat-button
          color="primary"
          mat-dialog-close>Cancel</button>
  <button type="button"
          mat-button
          color="primary"
          (click)="submitFeedback()">Submit feedback</button>
</mat-dialog-actions>